import SignInComp from "src/components/auth/SignInComp";
import Footer from "src/components/common/Footer";
import Header from "src/components/common/Header";

export default function SignInPage() {
  return (
    <div>
      <Header />
      <SignInComp />
      <Footer />
    </div>
  );
}
